<script setup lang="ts">
import { shallowRef, computed, onBeforeMount } from "vue";
import MergeTagDropdown from "./MTExtension/MergetagDropdown.vue";
import FontFamilyDrop from "./ToolBar/FontFamilyDrop/FontFamilyDrop.vue";
import BlockFormatDrop from "./ToolBar/BlockFormatDrop/BlockFormatDrop.vue";
import FontSizeInput from "./ToolBar/FontSizeInput.vue/FontSizeInput.vue";
import Link from "./ToolBar/Link/Link.vue";
import IEditorConfig from "../../types/IEditorConfig";
import TextAlign from "./ToolBar/TextAlign/TextAlign.vue";
import More from "./ToolBar/More/More.vue";
import OrderedList from "./ToolBar/Lists/OrderedList.vue";
import BulletList from "./ToolBar/Lists/BulletList.vue";
import Emoji from "./ToolBar/Emoji/Emoji.vue";
import TextColor from "./ToolBar/Colors/TextColor.vue";
import BGColor from "./ToolBar/Colors/BGColor.vue";
import Bold from "./ToolBar/Bold/Bold.vue";
import Italic from "./ToolBar/Italic/Italic.vue";
import Underline from "./ToolBar/Underline/Underline.vue";
import Strike from "./ToolBar/Strike/Strike.vue";
import RemoveFormat from "./ToolBar/RemoveFormat/RemoveFormat.vue";
import Nonbreaking from "./ToolBar/Nonbreaking/Nonbreaking.vue";
import CodeView from "./ToolBar/CodeView/CodeView.vue";
import { Editor } from "@tiptap/core";

const props = defineProps<{
  editor: Editor;
  config: IEditorConfig;
  propertyName?: string;
  inverse?: boolean;
}>();

const blockName = shallowRef();

const getComponent = () => {
  if (!props.propertyName) return;
  switch (props.propertyName) {
    case "blocks":
      return BlockFormatDrop;
    case "fontfamily":
      return FontFamilyDrop;
    case "fontsizeinput":
      return FontSizeInput;
    case "bold":
      return Bold;
    case "italic":
      return Italic;
    case "underline":
      return Underline;
    case "strikethrough":
      return Strike;
    case "removeformat":
      return RemoveFormat;
    case "nonbreaking":
      return Nonbreaking;
    case "textAlign":
      return TextAlign;
    case "more":
      return More;
    case "link":
      return Link;
    case "numlist":
      return OrderedList;
    case "bullist":
      return BulletList;
    case "forecolor":
      return TextColor;
    case "backcolor":
      return BGColor;
    case "mergefields":
      if (props.config.mergeTags) {
        return MergeTagDropdown;
      }
      return;
    case "emoticons":
      return Emoji;
    case "code":
      return CodeView;
    default:
      return null;
  }
};

onBeforeMount(() => {
  blockName.value = getComponent();
});
</script>

<template>
  <component
    :is="blockName"
    v-if="blockName"
    :editor="editor"
    :inverse="inverse"
    v-bind="
      propertyName === 'blocks'
        ? { language: config.language }
        : propertyName === 'fontfamily'
          ? { fonts: config.fonts }
          : propertyName === 'mergefields' ||
            propertyName === 'code' ||
            propertyName === 'link'
          ? { 'merge-tags': config.mergeTags }
            : propertyName === 'forecolor' || propertyName === 'backcolor'
              ? {
                  colors: config.colors,
                  colorPickerDark: config.colorPickerDark,
                }
              : {}
    "
  ></component>
</template>
